import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatError, MatFormField} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {TranslateModule} from "@ngx-translate/core";
import {EksternProtokollførtMøtedeltakerId, EksternProtokollførtMøtedeltakerModell, EksternProtokollførtMøtedeltakerSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {nyUuid} from "felles-ng2/støttefunksjoner/uuidGenerator";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

const debug = initDebugger('MøteprotokollRedigerDeltakerEksternKomponent');

export type SkjemaType = ReturnType<typeof MøteprotokollRedigerDeltakerEksternKomponent.opprettSkjema>;
export type SkjemaVerdier = SkjemaType['value'];


/**
 * Skjem for redigering av protokollført ekstern møtedeltaker
 */
@Component({
    selector: 'moeteprotokoll-rediger-deltaker-ekstern',
    templateUrl: 'møteprotokoll-rediger-deltaker-ekstern.html',
    styleUrl: 'møteprotokoll-rediger-deltaker-ekstern.scss',
    imports: [
        MatError,
        MatFormField,
        MatInput,
        MatSlideToggle,
        ReactiveFormsModule,
        StandardValideringsfeilPipe,
        TranslateModule,
        MatIcon,
        MatIconButton
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteprotokollRedigerDeltakerEksternKomponent {

    static valideringsfeil = {duplikat_navn: 'duplikat_navn'}

    static opprettSkjema(deltaker: EksternProtokollførtMøtedeltakerModell | null = null) {
        let skjema = new FormGroup({
            id: new FormControl<EksternProtokollførtMøtedeltakerId>(nyUuid(), {nonNullable: true, validators: Validators.required}),
            navn: new FormControl('', {nonNullable: true}), //validatorer settes via MøteprotokollRedigerDeltakerEksternKomponent.settFelterPåkrevd
            rolle: new FormControl('', {nonNullable: false, validators: FeltValidatorer.litenStreng}),
            kommentar: new FormControl('', {nonNullable: false, validators: FeltValidatorer.litenStreng}),
            skalSignere: new FormControl(false, {nonNullable: true})
        });
        MøteprotokollRedigerDeltakerEksternKomponent.settFelterPåkrevd(skjema);
        if (erIkkeNil(deltaker)) {
            skjema.patchValue({
                id: deltaker.id,
                navn: deltaker.navn,
                rolle: deltaker.rolle,
                kommentar: deltaker.kommentar,
                skalSignere: deltaker.skalSignere
            });
        }
        return skjema;
    }

    /** Endrer hvorvidt fekter som i utgangspunktet er påkrevd skal være påkrevd eller ei. */
    static settFelterPåkrevd(skjema: SkjemaType, påkrevd = true) {
        if (påkrevd) {
            skjema.controls.navn.addValidators(FeltValidatorer.litenIkkeTomStreng);
        } else {
            skjema.controls.navn.removeValidators(FeltValidatorer.litenIkkeTomStreng);
        }
    }

    static somSpesifikasjon(skjema: SkjemaVerdier): EksternProtokollførtMøtedeltakerSpesifikasjon {
        return {
            id: skjema.id!,
            navn: skjema.navn!,
            rolle: skjema.rolle ?? null,
            kommentar: skjema.kommentar ?? null,
            skalSignere: skjema.skalSignere!
        };
    }

    vedSlett = output<void>();
    skjema = input.required<SkjemaType>();

    valideringsfeil = MøteprotokollRedigerDeltakerEksternKomponent.valideringsfeil;

    constructor() {
    }

    slett() {
        this.vedSlett.emit();
    }
}
